export enum HubspotIntegrationsTabLinks {
  forms,
  'contact-settings',
  'deal-settings'
}

export enum CRMTabLinks {
  hubspot,
  salesforce,
}

export enum ProfileTabLinks {
  profile,
  password,
  authentication,
}


export enum AdProvidersTabLinks {
  google,
  facebook,
  bing,
  'linked-in',
  'tik-tok',
  snapchat
}

export enum EmailProvidersTabLinks {
  mailchimp
}

export enum PaymentProviderTabLinks {
  paddle,
}

export enum EcommerceProviderTabLinks {
  shopify,
}

export enum AnalyticsTabLinks {
  google,
}
